import { render, staticRenderFns } from "./DeleteRootFolderModal.vue?vue&type=template&id=90b354d2&scoped=true&"
import script from "./DeleteRootFolderModal.vue?vue&type=script&lang=ts&"
export * from "./DeleteRootFolderModal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90b354d2",
  null
  
)

export default component.exports